if (!customElements.get('lusso-product-rail')) {
  customElements.define(
    'lusso-product-rail',
    class LussoProductRail extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-product-rail-viewport]');
        this.items = [...this.querySelectorAll('[data-product-rail-item]')];
        this.previousButton = this.querySelector('[data-product-rail-previous]');
        this.nextButton = this.querySelector('[data-product-rail-next]');
        this.currentLabel = this.querySelector('[data-product-rail-current]');
        this.totalLabel = this.querySelector('[data-product-rail-total]');
        this.progress = this.querySelector('[data-product-rail-progress]');
        this.status = this.querySelector('[data-product-rail-status]');
        this.index = 0;
        this.scrollTicking = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.handleScroll = () => this.onScroll();
        this.handleResize = () => this.updateState(false);

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.viewport?.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });

        if (this.totalLabel) this.totalLabel.textContent = String(this.items.length).padStart(2, '0');
        this.updateState(false);
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
      }

      move(direction) {
        if (!this.viewport || this.items.length < 1) return;
        const visibleWidth = this.viewport.clientWidth;
        const targetScroll = Math.max(0, Math.min(this.viewport.scrollWidth - visibleWidth, this.viewport.scrollLeft + direction * visibleWidth * 0.82));
        this.viewport.scrollTo({
          left: targetScroll,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
        });
        if (this.status) this.status.textContent = direction > 0 ? 'Showing later products' : 'Showing earlier products';
      }

      onScroll() {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        window.requestAnimationFrame(() => {
          this.updateState(false);
          this.scrollTicking = false;
        });
      }

      updateState() {
        if (!this.viewport || this.items.length < 1) return;
        const viewportStart = this.viewport.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.items.forEach((item, index) => {
          const distance = Math.abs(item.offsetLeft - viewportStart);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.index = closestIndex;
        const maximumScroll = Math.max(1, this.viewport.scrollWidth - this.viewport.clientWidth);
        const scrollProgress = Math.min(1, Math.max(0, this.viewport.scrollLeft / maximumScroll));
        const visibleFraction = Math.min(1, this.viewport.clientWidth / this.viewport.scrollWidth);
        const progressScale = visibleFraction + scrollProgress * (1 - visibleFraction);

        if (this.currentLabel) this.currentLabel.textContent = String(this.index + 1).padStart(2, '0');
        if (this.progress) this.progress.style.setProperty('--ls-product-progress', progressScale.toFixed(4));
        if (this.previousButton) this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = this.viewport.scrollLeft >= maximumScroll - 2;
      }
    },
  );
}
